import {getTestProps} from '@benchling/js-test-utils';
import {css, StyleSheet} from 'aphrodite';
import classnames from 'classnames';
import React from 'react';

import * as Colors from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

/**
 * This component is used to indicate a table that is not versioned. It is shown
 * in stage entries only, and renders in place of the Input and Output tables while
 * the user is viewing a version other than the most recent.
 *
 * Once these objects are versioned with the rest of the stage entry, this component
 * will be removed.
 */

const styles = StyleSheet.create({
  container: {
    borderRadius: '4px',
    fontSize: '13px',
    color: Colors.NEAR_BLACK,
  },
  header: {
    background: 'transparent',
  },
  rightSide: {
    fontWeight: 'normal',
    color: Colors.GRAY_DARKER,
  },
  iconStyle: {
    marginRight: '0.4em',
  },
});

interface UnversionedTableProps {
  title: string;
}

export function UnversionedTable(props: UnversionedTableProps): JSX.Element {
  return (
    <div
      className="richObjectTable-container-wrapper richObjectTable-minimalMargin"
      {...getTestProps({component: 'UnversionedTable', element: 'root'})}
    >
      <div className={classnames('richObjectTable-container', css(styles.container))}>
        <div className={classnames('richObjectTable-header', css(styles.header))}>
          <div className="u-flex-grow">
            <BenchlingIcon icon="input" className={css(styles.iconStyle)} />
            {props.title}
          </div>
          <div
            className={classnames('u-flex-none', css(styles.rightSide))}
            {...getTestProps({component: 'UnversionedTable', element: 'unversionedMessage'})}
          >
            <BenchlingIcon icon="info-circle" className={css(styles.iconStyle)} />
            Version history not tracked
          </div>
        </div>
      </div>
    </div>
  );
}
